import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MediaService } from './media.service';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class InfoboxService {

  constructor(private http:HttpClient, private mediaService:MediaService) { }

  getBoxes() {
    return this.http.get<any>(`${environment.apiBaseUrl}/info-boxes?populate=*&sort[1]=order`);
  }

  getBox(id:string) {
    return this.http.get<any>(`${environment.apiBaseUrl}/info-boxes?filters[id][$eq]=${id}&populate=*`);
  }

  getBoxesFor(specid:string) {
    return this.http.get<any>(`${environment.apiBaseUrl}/info-boxes?filters[specialisaties][id][$eq]=${specid}&populate=*&sort[1]=order`);
  }

  populateBox(data:any) {
    let box = data;
    box.id = data.id;
    if(box.afbeelding) {
      box.afbeelding = this.mediaService.getMediaItemUrl(box.afbeelding);
    }

    if(box.url) {
      box.url = box.link.substring(box.link.indexOf("://")+3);
    } else {
      box.url = "";
    }
    return box;
  }
}
